import { CuraBadgeDistance } from '@rededor/cura-react'

interface Props {
  distanceInMeters: number
}

export const IconDistance = ({ distanceInMeters }: Props) => {
  if (distanceInMeters === 0) return null

  const label = distanceInMeters > 1000 ? 'km' : 'm'
  const distance =
    distanceInMeters > 1000 ? distanceInMeters / 1000 : distanceInMeters

  return <CuraBadgeDistance label={label} distance={distance} />
}
